namespace GeniuzPOS.ReportMasterData {
    export class Report_1504Columns {
        static columnsKey = 'ReportMasterData.Report_1504';
    }
}
